import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

import { stripIndent } from 'common-tags';
import { checkboxQuestion, dateQuestion, dropdownQuestion, linkQuestion, longAnswerQuestion, radioButtonQuestion, ratingQuestion, shortAnswerQuestion } from './question';
var categories = [{
  id: 'swag',
  name: 'Swag'
}, {
  id: 'charity',
  name: 'Charity'
}, {
  id: 'gifts',
  name: 'Gifts'
}];
export var rewards = [{
  __typename: 'Reward',
  id: '123',
  category: categories[0],
  name: 'A cool new sweater for the company you work for, make sure to choose a size',
  image: null,
  featured: false,
  points: 1000,
  description: stripIndent(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      You voted and here they are! We have some fancy new 1/4 zip sweaters for you to redeem!\n    "]))),
  disclaimer: null,
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '12323',
  category: categories[1],
  name: 'Plant a Tree 🌲',
  image: {
    id: 'a6fe1af4-7fe6-4048-b7be-1acf60147f00',
    blurhash: 'LOHBe--o0LOAnOtSX89aiwM|NGR-'
  },
  featured: true,
  points: 50,
  description: stripIndent(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      OneTreePlanted is a global non-profit organization that makes it easy for anyone to donate just one dollar to plant a tree. You can choose where to plant it too - in North America, Latin America, Australia & Asia, and Africa! The organization works with amazing reforestation partners around the world that need support to help get trees in the ground.\n      Check out their website to learn more!\n    "]))),
  disclaimer: null,
  onWishList: true,
  questions: [dateQuestion, shortAnswerQuestion, dropdownQuestion, radioButtonQuestion, linkQuestion, ratingQuestion, checkboxQuestion, longAnswerQuestion],
  requiresShippingAddress: true,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '345345',
  category: categories[1],
  name: '$5 Donation: Hollaback!',
  image: {
    id: 'b2a93f3a-5b0f-4b26-b79b-de74241fa000',
    blurhash: 'LE9jl.n10f9ttTROt7t79sX9$gxb'
  },
  featured: true,
  points: 165,
  description: stripIndent(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      <b>Who we are:</b> Hollaback! is a global, people-powered movement to end harassment \u2014 in all its forms. We believe that we all deserve to be who we are, wherever we are.\n      <b>Mission:</b> Our mission is to end harassment in all its forms by transforming the culture that perpetuates hate and harassment.\n      Location: global\n      Website: <a href=\"https://www.ihollaback.org\">hollaback!</a>\n    "]))),
  disclaimer: "<p>Some <span style='color: red'>default</span> <strong>disclaimer</strong> idk<p>",
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: 'c6b3d79d-3b25-4e8d-828e-417ecc3a1ae4',
  category: categories[1],
  name: '$5 Donation: #HateIsAVirus',
  image: {
    id: 'fc4514e6-70ca-46fe-e193-a966c926e300',
    blurhash: 'LIByHW-pEREObHNHWUWC0gad-SoJ'
  },
  featured: false,
  points: 165,
  description: stripIndent(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      Hate Is A Virus is a nonprofit community of mobilizers and amplifiers that exists to dismantle racism and hate.\n      Here\u2019s how we\u2019re taking action: (1) Raise Awareness, (2) Educate & Equip, (3) Informed Action\n      Through fundraising, we\u2019ve supported community leaders like James Choi founder of Cafe Dulce and board member of Little Tokyo Community Council who have used the money raised to support small restaurants and feed frontline workers. We have also donated to organizations including Nikkei Progressives, Act to Change, Kollaboration, Laos In The House, Arts Administrators of Color and more over the past year.\n      Location: global/United States\n      Website: <a href=\"https://hateisavirus.org/about-us\">#HateIsAVirus</a>\n    "]))),
  disclaimer: null,
  onWishList: true,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '123809',
  category: categories[2],
  name: "S'well",
  image: {
    id: 'ac858154-3164-46a9-a699-707b28e01000',
    blurhash: 'LCDvTR%MD%4:?wo#RORO_NIoxBRO'
  },
  featured: false,
  points: 2000,
  description: stripIndent(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      Stay hydrated at the office.\n      Redeem this reward to get your very own S'well bottle (up to a value of $50). Choose wisely: <a href=\"http://www.swellbottle.com/shop-swell-bottle/\">http://www.swellbottle.com/shop-swell-bottle/</a>\n    "]))),
  disclaimer: null,
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '809123',
  category: categories[2],
  name: 'Nespresso Round Head Coffee & Espresso Maker',
  image: {
    id: 'dacf1e5d-d10d-45a0-3304-798e58007c00',
    blurhash: 'LTE2a:jr0Kog^+RkD%t7afNGs:tQ'
  },
  featured: false,
  points: 6700,
  description: stripIndent(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      Vertuo Black Round Head\n      Vertuo prepares freshly brewed coffee and authentic espresso with crema at the touch of a button thanks to the revolutionary Centrifusion and code reading parametric extraction technologies.\n    "]))),
  disclaimer: null,
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '21965',
  category: categories[0],
  name: 'Advocamp Mug ☕️',
  image: {
    id: '43b65c75-3655-4c6d-358a-e6ea965eb300',
    blurhash: 'LQIV;{o15;R-}rjZEij]buxan%xZ'
  },
  featured: false,
  points: 50,
  description: stripIndent(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    <b>Pembrokeshire and Cardiganshire</b> are adjoining historical agricultural counties in South West Wales. Welsh Corgis were cattle herding dogs; the type of herding dog referred to as \"heelers\",\n    meaning that they would nip at the heels of the larger animals to keep them on the move. The combination of their low height off the ground and innate agility of Welsh Corgis would allow\n    them to avoid the hooves of cattle. The term \"Corgi\" means either cur dog or dwarf dog (cor = dwarf, gi = lenitive of ci, dog) in the Welsh language, which was not intended as an insult to\n    the dog's size, rather as a purely descriptive term. Different tales have been told of the Corgi's origin: some believe that the two modern breeds evolved from a shared ancestry, while\n    others attribute the import of the Pembroke Welsh Corgi to Flemish weavers starting around the 10th century. Further theories on the origin of the Pembroke variety suggest that they may\n    have originated from central European herding breeds from the area around modern Germany. Depending on the time period when these dogs were imported to Wales, they could have been either\n    Deutsche Bracken, or Dachshund. The Cardigan Welsh Corgi has been attributed to the influences of Nordic settlers in the region. Dogs of similar dimensions exist in modern Scandinavia,\n    called the Swedish Vallhund, and it is claimed by some historians that these two breeds share a common ancestor.  In the late 19th century, farmers in began to switch from cattle to sheep\n    but the corgi is not suited for working sheep. Similarities between the Welsh Corgis have been attributed to cross-breeding between the two, or simply selected breeding from those who wished\n    to have the Cardigan variety appear closer in nature to the Pembroke.\n    "]))),
  disclaimer: '<p>Custom disclaimer</p>',
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '45622',
  name: 'Free Ice Cream',
  image: {
    id: 'b2a93f3a-5b0f-4b26-b79b-de74241fa000',
    blurhash: 'LE9jl.n10f9ttTROt7t79sX9$gxb'
  },
  description: stripIndent(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      <b>Who we are:</b> Hollaback! is a global, people-powered movement to end harassment \u2014 in all its forms. We believe that we all deserve to be who we are, wherever we are.\n      <b>Mission:</b> Our mission is to end harassment in all its forms by transforming the culture that perpetuates hate and harassment.\n      Location: global\n      Website: <a href=\"https://www.ihollaback.org\">hollaback!</a>\n    "]))),
  disclaimer: null,
  featured: false,
  points: 1000,
  category: categories[0],
  questions: null,
  onWishList: false,
  requiresShippingAddress: true,
  perksCount: 1
}, {
  __typename: 'Reward',
  id: '123232111',
  name: 'Free Tree 🌲',
  image: null,
  description: stripIndent(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      You get a tree You get a tree kdskjhk jhk kj dkajhk dkjh dajk djkj dakjh adkj.\n    "]))),
  disclaimer: null,
  category: categories[0],
  featured: false,
  onWishList: false,
  points: 500,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 2
}, {
  __typename: 'Reward',
  id: '678234',
  category: categories[0],
  name: 'Advocamp Water Bottle',
  image: {
    id: 'effa1e1c-7f15-4047-ad26-46783538e300',
    blurhash: 'LFDnHotRt8xt_KRQRRozWFRkRjWB'
  },
  featured: false,
  points: 50,
  description: stripIndent(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      We all need to drink a little more water! We know it's old, but that's why it doesn't cost you much! Plus they're still awesome. Get a spiffy Advocamp waterbottle today.\n    "]))),
  disclaimer: null,
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}, {
  __typename: 'Reward',
  id: '5671234',
  category: categories[0],
  name: 'Influitive Socks!',
  image: {
    id: '979d8132-1047-494e-a6c6-52d3adebce00',
    blurhash: 'LPIM_pQ:GEOV0|$*$jW-GXNb+djZ'
  },
  featured: false,
  points: 350,
  description: stripIndent(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      No one should ever suffer from blisters or cold feet. Especially our Influvians! Which is why we are offering Influitive socks to keep you warm during those cold, dreary days. Redeem this reward to get your very own pair!!\n    "]))),
  disclaimer: null,
  onWishList: false,
  questions: null,
  requiresShippingAddress: false,
  perksCount: 0
}];
export var rewardConnection = {
  __typename: 'RewardConnection',
  edges: rewards.map(function (r, index) {
    return {
      node: r,
      cursor: "".concat(index)
    };
  }),
  totalCount: rewards.length,
  pageInfo: {
    startCursor: '0',
    endCursor: "".concat(rewards.length - 1),
    hasNextPage: false,
    hasPreviousPage: false
  }
};